import axios from 'axios';
import localforage from 'localforage';
import config from './../config';

export default {
  build(token = '', endpoint = 'graphql') {
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    const instance = axios.create({
      baseURL: `${config.tmsGraphqlApiUrl}/${endpoint}`,
      headers,
    });

    return function runQuery(query, method = '') {
      let payload = {};
      if (typeof query === 'string') {
        payload.query = query;
      } else {
        payload = query;
      }

      return instance.post(`/${method}`, payload)
        .then(resp => resp.data);
    };
  },
  buildRetry(token = '', endpoint = 'graphql') {
    const sendToMattermost = (data) => {
      const baseUrl = window.location.origin;
      const content = `TMS failed post data. method: ${data.method} error: ${data.error}. For server ${baseUrl}`;
      this.sendMattermostNotif(content);
    };

    return async (query, method = '', maxRetry = 5, delay = 500) => {
      let retry = 0;
      let data = {};
      const apiRetry = this.build(token, endpoint);

      const runAPi = async () => {
        retry++;
        await apiRetry(query, method)
          .then((resp) => {
            data = resp;
          })
          .catch((error) => {
            if (error && retry <= maxRetry) {
              setTimeout(() => {
                runAPi();
              }, delay);
            } else {
              data = {};
              try {
                setTimeout(() => {
                  if (window.location.origin.indexOf('localhost') === -1) {
                    sendToMattermost({
                      method,
                      error,
                    });
                  }
                }, 1e3);
              } catch (err) {
                console.log('error catch', err);
              }
            }
          });
      };

      await runAPi();

      return Promise.resolve(data);
    };
  },
  login(payload) {
    return axios.post(config.tmsLoginApiUrl, payload).then(resp => resp.data);
  },
  get_order_status(payload) {
    return axios.post(config.tmsTrackingGetOrderStatus, payload).then(resp => resp.data);
  },
  get_positions(payload) {
    return axios.post(config.tmsTrackingGetPositions, payload).then(resp => resp.data);
  },
  get_realtime_position(payload) {
    return axios.post(config.tmsTrackingGetRealtimePosition, payload).then(resp => resp.data);
  },
  check_username(token, username) {
    const instance = axios.create({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return instance
      .post(config.tmsCheckUsernameUrl, username)
      .then(resp => resp.data);
  },
  check_namespace(token, namespace) {
    const instance = axios.create({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return instance
      .post(config.tmsCheckNamespaceUrl, namespace)
      .then(resp => resp.data);
  },
  check_external_id(token, external_id) {
    const instance = axios.create({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return instance
      .post(config.tmsCheckExternalIdUrl, external_id)
      .then(resp => resp.data);
  },
  get_positions_by_deviceid(token, payload) {
    const instance = axios.create({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return instance
      .post(config.tmsGetPositionsByDeviceid, payload)
      .then(resp => resp.data);
  },
  upload(files, params) {
    const data = new FormData();

    Object.keys(files).map((key) => {
      data.append(`file_${key}`, files[key]);
      return true;
    });

    Object.keys(params).map((key) => {
      data.append(key, params[key]);
      return true;
    });

    return axios.post(config.tmsUploadUrl, data).then(resp => resp.data);
  },
  uploadAuth(token, files, params) {
    const data = new FormData();
    const instance = axios.create({
      headers: {
        Authorization: `Bearer ${token}`,
        // 'Content-Type': 'application/json',
      },
    });

    Object.keys(files).forEach((key) => {
      data.append(`file_${key}`, files[key]);
      return true;
    });

    Object.keys(params).forEach((key) => {
      data.append(key, params[key]);
      return true;
    });

    return instance
      .post(`${config.tmsUploadUrl}_auth`, data)
      .then(resp => resp.data);
  },
  createStorage() {
    localforage.config({
      name: 'hawk_storage',
      version: config.storageVersion,
    });
    return localforage;
  },
  sendMattermostNotif(content) {
    return axios.post(config.tmsSendMattermostNotifUrl, { content }).then(resp => resp.data);
  },
};



// WEBPACK FOOTER //
// ./src/api/tmsApi.js